<template>
  <div>
    <el-card shadow="always">
      <b-row class="mt-2">
        <b-col>
          <!--基础信息-->
          <div style="font-size: 14px; color: #606266;">
            <span>No：{{ formData.prjNo }}</span>
            <el-divider direction="vertical"></el-divider>
            <span>Status：{{ formData.prjStatusName }}</span>
            <el-divider direction="vertical"></el-divider>
            <span
              >Create：{{ formData.createByName }} at
              {{ formData.createDate }}</span
            >
            <el-divider direction="vertical"></el-divider>
            <span
              >Modify：{{ formData.modifyByName }} at
              {{ formData.modifyDate }}</span
            >
          </div>
          <div class="d2-mt">
            <el-form ref="form" :model="formData" :rules="rules" size="small">
              <el-row :gutter="20">
                <el-col :span="12">
                  <el-form-item
                    :label="$l('label_prjTitle') || '项目名称'"
                    prop="prjTitle"
                  >
                    <el-input
                      v-model="formData.prjTitle"
                      :disabled="isViewDisabled"
                      :placeholder="$l('tips_prjTitle') || '请输入项目名称'"
                      size="small"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    :label="$l('label_beginDate') || '开始日期'"
                    prop="beginDate"
                  >
                    <el-date-picker
                      v-model="formData.beginDate"
                      type="date"
                      :placeholder="
                        $l('tips_beginDate') || '请选择项目开始日期'
                      "
                      value-format="yyyy-MM-dd"
                      :disabled="isViewDisabled"
                      size="small"
                      style="width:100%;"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    :label="$l('label_endDate') || '结束日期'"
                    prop="endDate"
                  >
                    <el-date-picker
                      v-model="formData.endDate"
                      type="date"
                      :placeholder="$l('tips_endDate') || '请选择项目结束日期'"
                      value-format="yyyy-MM-dd"
                      :disabled="isViewDisabled"
                      size="small"
                      style="width:100%;"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item
                    :label="$l('label_custCode') || '项目客户'"
                    prop="custCode"
                  >
                    <dict-select
                      v-model="formData.custCode"
                      url="/digitalCenter/common/dict/customer"
                      :placeholder="$l('tips_custCode') || '请选择项目客户'"
                      size="small"
                      style="width: 100%"
                      disabled
                      filterable
                      clearable
                    ></dict-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    :label="$l('label_prjCategoryCode') || '项目类别'"
                    prop="prjCategoryCode"
                  >
                    <dict-select
                      v-model="formData.prjCategoryCode"
                      url="/digitalCenter/common/dict/prjCategory"
                      :placeholder="
                        $l('tips_prjCategoryCode') || '请选择项目类别'
                      "
                      size="small"
                      style="width: 100%"
                      disabled
                      filterable
                      clearable
                    ></dict-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    :label="$l('label_projectType') || '项目角色'"
                    prop="projectType"
                  >
                    <el-select
                      v-model="formData.projectType"
                      filterable
                      clearable
                      :placeholder="$l('tips_projectType') || '请选择项目角色'"
                      style="width:100%;"
                      size="small"
                    >
                      <el-option
                        v-for="item in projectTypeArray"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    :label="$l('label_masterCategoryCode') || '产品类别'"
                    prop="masterCategoryCode"
                  >
                    <dict-select
                      v-model="formData.masterCategoryCode"
                      url="/digitalCenter/common/dict/masterCategory"
                      :placeholder="
                        $l('tips_masterCategoryCode') || '请选择产品类别'
                      "
                      size="small"
                      disabled
                      filterable
                      clearable
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item
                    :label="$l('label_sampleType') || '打样需求'"
                    prop="sampleType"
                  >
                    <el-select
                      v-model="formData.sampleType"
                      disabled
                      filterable
                      size="small"
                      style="width:100%;"
                    >
                      <el-option
                        value="N"
                        :label="$l('option_sampleType_1') || '无需打样'"
                      />
                      <el-option
                        value="S"
                        :label="$l('option_sampleType_2') || '样品打样'"
                      />
                      <el-option
                        value="M"
                        :label="$l('option_sampleType_3') || '面料打样'"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item
                    :label="$l('label_sampleNo') || '打样产品编号'"
                    prop="sampleNo"
                  >
                    <el-input
                      v-model="formData.sampleNo"
                      size="small"
                      clearable
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :label="$l('label_supCode') || '打样工厂'"
                    prop="supCode"
                  >
                    <dict-select
                      :placeholder="$l('tips_supCode') || '请选择打样工厂'"
                      size="small"
                      clearable
                      filterable
                      v-model="formData.supCode"
                      url="/master/common/dict/scmCooperated"
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item
                    :label="$l('label_prjOwnerCode') || '项目负责人'"
                    prop="prjOwnerCode"
                  >
                    <dict-select
                      v-model="formData.prjOwnerCode"
                      url="/digitalCenter/common/dict/baseUser"
                      :placeholder="
                        $l('tips_prjOwnerCode') || '请选择项目负责人'
                      "
                      :disabled="isViewDisabled"
                      size="small"
                      filterable
                      clearable
                      :options="{ label: 'label', value: 'code' }"
                    ></dict-select>
                  </el-form-item>
                </el-col>
                <el-col :span="18">
                  <el-form-item
                    :label="$l('label_prjParticipant') || '项目参与人'"
                    prop="prjParticipant"
                  >
                    <dict-select
                      v-model="formData.prjParticipant"
                      url="/digitalCenter/common/dict/baseUser"
                      :placeholder="
                        $l('tips_prjParticipant') || '请选择项目参与人'
                      "
                      :disabled="isViewDisabled"
                      size="small"
                      filterable
                      :multiple="true"
                      clearable
                      :options="{ label: 'label', value: 'code' }"
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <el-form-item :label="$l('label_prjMemo') || '项目说明'">
                    <el-input
                      type="textarea"
                      v-model="formData.prjMemo"
                      maxlength="4000"
                      :disabled="isViewDisabled"
                      :placeholder="$l('tips_prjMemo') || '请输入项目说明'"
                      clearable
                      rows="4"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div>
            <Attribute
              ref="attribute"
              :params="attrParams"
              size="small"
              :disabled="isViewDisabled"
            />
          </div>
          <div>
            <el-row :gutter="20">
              <el-col :span="12">
                <schedule
                  ref="schedule"
                  :params="prjParams"
                  :height="163"
                  :autoLoad="true"
                  :disabled="isViewDisabled"
                />
              </el-col>
              <el-col :span="12">
                <doc
                  ref="doc"
                  :params="prjParams"
                  :autoLoad="true"
                  :height="163"
                  :disabled="isViewDisabled"
                />
              </el-col>
            </el-row>
          </div>
          <div class="d2-mt">
            <el-row>
              <el-col :span="24">
                <el-button
                  @click="save"
                  type="primary"
                  size="small"
                  v-if="!isViewDisabled"
                  >{{ $l('btn_save') || 保存 }}</el-button
                >
              </el-col>
            </el-row>
          </div>
        </b-col>
      </b-row>
    </el-card>
  </div>
</template>
<script>
import schedule from './components/schedule'
import doc from './components/doc'
import Attribute from '@/views/digital/components/attribute'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { mapActions } from 'vuex'
export default {
  mixins: [EditLoading],
  components: {
    schedule,
    doc,
    Attribute
  },
  data() {
    return {
      activeName: 'info',
      pageHeader: '',
      isViewDisabled: false,
      dialogVisible: false,
      projectTypeArray: [],
      formData: {
        prjCode: '',
        prjNo: '',
        prjTitle: '',
        prjCategoryCode: '',
        projectType: '',
        masterCategoryCode: '',
        categoryCode: '',
        custCode: '',
        prjOwnerCode: '',
        prjParticipant: '',
        beginDate: '',
        endDate: '',
        sampleType: '',
        sampleNo: '',
        supCode: '',
        linkPrjCode: '',
        prjMemo: '',
        prjStatus: 'Y',
        createByName: '',
        createDate: '',
        modifyByName: '',
        modifyDate: ''
      },
      rules: {
        prjTitle: [
          {
            required: true,
            message: this.$l('tips_prjTitle') || '请输入项目名称',
            trigger: 'blur'
          },
          { max: 50, message: '长度在50个字符以内', trigger: 'blur' }
        ],
        beginDate: [
          {
            required: true,
            message: this.$l('tips_beginDate') || '请选择项目开始日期',
            trigger: 'blur'
          }
        ],
        endDate: [
          {
            required: true,
            message: this.$l('tips_endDate') || '请选择项目结束日期',
            trigger: 'blur'
          }
        ],
        prjCategoryCode: [
          {
            required: true,
            message: this.$l('tips_prjCategoryCode') || '请选择项目类别',
            trigger: 'blur'
          }
        ],
        custCode: [
          {
            required: true,
            message: this.$l('tips_custCode') || '请选择项目客户',
            trigger: 'blur'
          }
        ],
        prjOwnerCode: [
          {
            required: true,
            message: this.$l('tips_prjOwnerCode') || '请选择项目负责人',
            trigger: 'blur'
          }
        ]
      },
      tabVisible: {
        scheduleAndParticipant: false,
        product: false,
        customerRecommend: false,
        quotation: false,
        prjSample: false,
        material: false,
        feedback: false
      }
    }
  },
  // 侦听器
  watch: {
    '$route.params'() {
      if (this.$route.params.prjCode && this.$route.params.pageType) {
        this.formLoad()
      }
    }
  },
  mounted() {
    if (this.$route.params.prjCode && this.$route.params.pageType) {
      this.formLoad()
    }
  },
  computed: {
    // 根据打样类型控制tab显隐
    visible() {
      if (this.formData.sampleType === 'N') {
        return { ...this.tabVisible, prjSample: false, material: false }
      } else if (this.formData.sampleType === 'S') {
        return {
          ...this.tabVisible,
          product: false,
          customerRecommend: false,
          quotation: false,
          material: false
        }
      } else if (this.formData.sampleType === 'M') {
        return {
          ...this.tabVisible,
          product: false,
          customerRecommend: false,
          quotation: false,
          prjSample: false
        }
      }
      return {}
    },
    attrParams() {
      return {
        infoCode: this.formData.prjCode,
        templateCategoryCode: this.formData.prjCategoryCode,
        masterCategoryCode: this.formData.masterCategoryCode,
        templateType: 'P'
      }
    },
    prjParams() {
      return {
        prjCode: this.formData.prjCode,
        prjCategoryCode: this.formData.prjCategoryCode,
        masterCategoryCode: this.formData.masterCategoryCode
      }
    }
  },
  methods: {
    ...mapActions('admin/page', ['close']),
    formLoad() {
      let prjCode = this.$route.params.prjCode
      let pageType = this.$route.params.pageType
      this.getProjectTypeArray()
      if (pageType === 'detail') {
        this.pageHeader = this.$l('label_page_header_view') || '项目详情'
        this.isViewDisabled = true
      } else {
        this.pageHeader = this.$l('label_page_header_edit') || '项目编辑'
        this.isViewDisabled = false
      }
      let param = { prjCode: prjCode }
      this.$api.projectInfoDetailApi(param).then((res) => {
        let tempData = res.body
        if (tempData.prjStatus === 'S') {
          // 草稿状态，将项目名称设置为空，保存时必须填写
          tempData.prjTitle = ''
        }
        this.formData = tempData
        this.$refs.attribute.load(this.attrParams)
        setTimeout(() => {
          // this.$refs.participant.load();
        }, 1500)
      })
    },
    save() {
      const form = this.$refs.form
      const attrForm = this.$refs.attribute.$refs.form

      validate.formValidate([form, attrForm], (valid) => {
        if (valid) {
          this.formData.attrData = this.$refs.attribute.getFormData()
          this.loadingOpen()
          this.$api
            .projectInfoSaveApi(this.formData)
            .then(() => {
              this.loadingClose()
              this.saveOkQuestion()
            })
            .catch(() => {
              this.loadingClose()
            })
        }
      })
    },
    saveOkQuestion() {
      this.$alert(
        this.$l('tips_save_ok') || '保存成功',
        this.$l('tips_question_title') || '提示信息',
        {
          confirmButtonText: '确定',
          callback: () => {
            this.closeCurPage()
          }
        }
      )
    },
    async closeCurPage() {
      this.reset()
      // 关闭当前页面
      await this.close({
        tagName: this.$route.fullPath,
        showConfirm: false
      })
    },
    reset() {
      this.activeName = 'info'
      this.isViewDisabled = false
      this.dialogVisible = false
      this.$refs.form.resetFields()
    },
    getProjectTypeArray() {
      this.$api.systemDict({ dictType: 'projectType' }).then((res) => {
        this.projectTypeArray = res.body.data.map((item) => {
          return {
            label: item.label,
            value: item.value
          }
        })
      })
    }
  }
}
</script>
